/* eslint-disable import/prefer-default-export */
import { css } from "styled-components";

// TODO: this is not the best approach. this should be handled by the provider
// nav container
export const providerSettingsContainerStyle = css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 auto;
  /* 1024 + 2rem padding */
  max-width: 66rem;
  padding: 2rem 1rem;
  width: 100%;

  h1 {
    margin-bottom: 0;
  }

  h2 {
    letter-spacing: -0.066875rem;
  }

  h3 {
    letter-spacing: -0.025rem;
  }
`;
